import React, { useEffect } from 'react'
import { Field, getFormValues } from 'redux-form'
import { connect } from 'react-redux'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { getBPCompanies } from 'ducks/vendorMaintenance'
import { getCompanies } from 'ducks/options'
import { SubDetailContainer } from './styled'

// import r from 'reactotron-react-js'

export const BlockForm = (props) => {
  const { valueForm, vendorCompanies, change, companies } = props
  const { status, sn, accountGroup, blockCompanies } = valueForm

  // r.log({ blockCompanies, blockAllCompany, vendorCompanies: vendorCompanies.data })

  useEffect(() => {
    if (!vendorCompanies.data.length && !vendorCompanies.loading) {
      props.getBPCompanies(valueForm.vendorCode)
    }
  }, [])

  useEffect(() => {
    if (blockCompanies) {
      if (vendorCompanies.data.length === blockCompanies.length) {
        if (valueForm.blockAllCompany === undefined || valueForm.blockAllCompany === null) {
          change('blockAllCompany', true)
        }
      }
    }
  }, [vendorCompanies.data])

  const centralAndAllPurchasingEditable = () => {
    if (status === undefined || status === 0) {
      return true
    } else if (status === 5 && sn) {
      return true
    } else {
      return false
    }
  }

  const showBlockAccountForm = () => {
    if ((accountGroup === 'ZRPT'||accountGroup === 'ZRCP') || (status === 2 && sn)) {
      return true
    } else {
      return false
    }
  }

  const blockCompanyEditable = () => {
    if ((accountGroup === 'ZRPT'||accountGroup === 'ZRCP') && (status === undefined || status === 0)) {
      return true
    } else if (status === 2 && sn) {
      return true
    } else {
      return false
    }
  }

  const onChangeBlockAllCompany = (value) => {
    // vendorCompanies.data.forEach(c => {
    //   change(`block_${c.value}`, value)
    // })

    // if (value) {
    //   change('blockCompanies', [...vendorCompanies.data.map(c => c.value)])
    // } else {
    //   change('blockCompanies', [])
    // }
  }

  const onChangeBlockCompany = (value, company) => {
    const { blockCompanies } = valueForm
    let newValue = []

    if (value) {
      if (blockCompanies.find(c => c === company) === undefined) {
        newValue = blockCompanies.concat(company)
      }
    } else {
      newValue = blockCompanies.filter(c => c !== company) || []
    }

    change('blockCompanies', [...newValue])
    //change('blockAllCompany', (newValue.length === vendorCompanies.data.length))
  }

  const getCompanyName = (value) => {
    var company = companies.data.find(c => c.value === value)

    return company ? company.text : value
  }

  return (
    <SubDetailContainer>
      <div className='subTitle'>Block</div>
      <div className='rowFields'>
        <Field 
          name='centralBlock' 
          label='Central Block' 
          editable={centralAndAllPurchasingEditable()}
          type={type.checkbox} 
          component={FieldInput} />
        <Field 
          name='allPurchasingBlock' 
          label='Block All Purchasing' 
          editable={centralAndAllPurchasingEditable()}
          type={type.checkbox} 
          component={FieldInput} />
      </div> 
      {
        showBlockAccountForm() ?
          <React.Fragment>
            <div className='sectionTitle'>Accounting Block</div>
            <div className='rowFields'>
              {
                vendorCompanies.data.length ? 
                  <Field 
                    name='blockAllCompany' 
                    label='Block All Company' 
                    editable={blockCompanyEditable()}
                    type={type.checkbox}
                    specialOnChange={onChangeBlockAllCompany}
                    component={FieldInput} /> : null
              }
            </div>
          </React.Fragment> : null
      }
      {
        status === 4 ?
        blockCompanies.map(c => 
          <Field 
            name={`block_${c}`} 
            label={getCompanyName(c)}
            editable={false}
            type={type.checkbox}
            component={FieldInput} />
        ) :
        showBlockAccountForm() ? 
          vendorCompanies.data.map(c => 
            <Field 
              name={`block_${c.value}`} 
              label={c.text}
              editable={blockCompanyEditable() && valueForm.blockAllCompany !== true}
              type={type.checkbox}
              specialOnChange={(value) => onChangeBlockCompany(value, c.value)} 
              component={FieldInput} />
          ) : null
      }
    </SubDetailContainer>
  )
}

const mapStateToProps = (state, props) => {
  const valueForm = getFormValues('formVendorMaintenance')(state) || {}
  return ({
    valueForm,
    vendorCompanies: state.vendorMaintenance.vendorCompanies,
    companies: state.options.companies,
  })
}
  
const mapDispatchToProps = {
  getBPCompanies,
  getCompanies
}

export default connect(mapStateToProps, mapDispatchToProps)(BlockForm)